var AppChartsService = (function () {
    function AppChartsService() {
    }
    // 初始化图表
    AppChartsService.prototype.chartsInit = function (options, target) {
        var charts = echarts.init(target);
        charts.setOption(options);
    };
    //设置图表属性
    AppChartsService.prototype.setChartsAttribute = function (theme, type, data, max) {
        var opts = {}, objKey = { "radar": "radar" }[type] || "radar", indicatorList = this.formatChartsData(data, "kaName"), valueList = this.formatChartsData(data, "kaScore");
        opts[objKey] = theme.base;
        opts[objKey]["indicator"] = this.setChartsAttributeIndicator(theme.indicatorAxisLabel, indicatorList, max);
        opts["series"] = this.setChartsSeries(theme.series, type, valueList);
        return opts;
    };
    //设置Indicator
    AppChartsService.prototype.setChartsAttributeIndicator = function (indicatorOpts, dataList, max) {
        var indicator = [];
        for (var i = 0, len = dataList.length; i < len; i += 1) {
            indicator[i] = {
                "name": dataList[i],
                "max": max
            };
            if (i == 0) {
                indicator[i].axisLabel = indicatorOpts;
            }
        }
        return indicator;
    };
    // 设置图表Series
    AppChartsService.prototype.setChartsSeries = function (seriesOpts, type, dataList) {
        var series = {};
        series["type"] = type;
        series["symbol"] = seriesOpts.symbol;
        series["data"] = this.setChartsSeriesData(seriesOpts, dataList);
        return series;
    };
    //设置Series的data
    AppChartsService.prototype.setChartsSeriesData = function (seriesOpts, dataList) {
        var data = [];
        for (var i = 0, len = dataList.length; i < len; i += 1) {
            data[i] = {};
            data[i]['itemStyle'] = {};
            data[i]['itemStyle']['normal'] = {};
            data[i]['value'] = dataList[i];
            data[i]['itemStyle']['normal'] = seriesOpts.seriesDataStyle[i];
        }
        return data;
    };
    // 格式化数据
    AppChartsService.prototype.formatChartsData = function (data, keyName) {
        var arr = [];
        if (keyName !== "kaScore") {
            data[0].forEach(function (v) {
                arr.push(v[keyName]);
            });
        }
        else {
            var _loop_1 = function (i, len) {
                arr[i] = [];
                data[i].forEach(function (v) {
                    arr[i].push(v[keyName]);
                });
            };
            for (var i = 0, len = data.length; i < len; i += 1) {
                _loop_1(i, len);
            }
        }
        return arr;
    };
    return AppChartsService;
}());
export { AppChartsService };



// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.service.ts.pre-build-optimizer.js